"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "edolo": {
    "885d8099": [{
      "hkey": "9e735acb",
      "slug": "edolo",
      "name": "Edolo",
      "primary": true,
      "skipSearch": false
    }],
    "costa": [{
      "hkey": "9e735acb",
      "slug": "edolo",
      "name": "Edolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c67bf0a4": [{
      "hkey": "5401eb35",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "mu": [{
      "hkey": "5401eb35",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "edolo"
    }]
  }
};
exports["default"] = _default;